<template>
  <div class="template-steps-with-icons">
    <div class="content pb-5 pt-3">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <MaterialHeader :content="content"/>
            <div v-if="content.acf.icon_before_title.text"
                 class="icon-before-title d-flex justify-content-start align-items-center mb-4 pt-3">
              <img v-if="content.acf.icon_before_title.icon" :src="content.acf.icon_before_title.icon"/>
              <p :style="{
                color: content.acf.icon_before_title.text_color ? content.acf.icon_before_title.text_color : 'inherit'
                }" class="m-0 ml-4">{{content.acf.icon_before_title.text}}</p>
            </div>
            <h2 class="text-primary bold mb-4 material-title"
                v-html="content.title.rendered"></h2>
            <p class="material-subtitle text-secondary mb-5">{{content.acf.subtitle}}</p>
          </div>
        </div>
        <div class="content-body">
          <div v-if="content.acf.text_before_accordion"
               class="text-before-accordion mb-5"
               v-html="content.acf.text_before_accordion"></div>
          <div class="accordion">
            <template v-for="(item, i) in content.acf.accordion">
              <div v-if="item.header" class="accordion-item" :key="`acc-${i}`">
                <div class="row">
                  <div class="col-12">
                    <h3 class="pointer d-flex justify-content-between align-items-center"
                        v-b-toggle="`collapse-acc-${i}`">
                      <span class="accordion-title">
                        <span class="mr-4 header-icon" v-if="item.header_icon">
                          <img :src="item.header_icon">
                        </span>
                        <span class="bold">{{item.header}}</span>
                      </span>
                      <span :class="{'d-none': documentGenerating}">
                        <img src="@/assets/icons/plus-secondary-thin.svg" class="img-fluid when-closed">
                        <img src="@/assets/icons/arrow-primary.svg" class="img-fluid when-open">
                      </span>
                    </h3>
                    <b-collapse :id="`collapse-acc-${i}`" :visible="documentGenerating">
                      <div class="accordion-content mt-2">
                        <div class="d-flex">
                          <div class="addition-icon-on-the-left">
                            <img :src="item.additional_icon_on_the_left" v-if="item.additional_icon_on_the_left">
                          </div>
                          <div class="w-100">
                            <div v-html="item.content"></div>
                            <div v-if="item.gallery.length">
                              <Gallery :images="item.gallery"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MaterialHeader from '@/templates/template-parts/MaterialHeader.vue';
import Gallery from '@/templates/template-parts/Gallery.vue';

export default {
  props: {
    content: Object,
    documentGenerating: null,
  },
  data() {
    return {
      lightboxItems: [],
      lightboxIndex: null,
    };
  },
  components: {
    MaterialHeader,
    Gallery,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.icon-before-title {
  img {
    max-width: 40px;
  }
  p {
    font-size: 20px;
  }
}
.material-subtitle {
  font-size: 25px;
}
@include media-breakpoint-down(lg) {
  .material-title {
    font-size: 24px;
  }
  .material-subtitle {
    font-size: 20px;
  }
}
.accordion {
  .accordion-item {
    &:first-of-type {
      border-top: 1px solid $secondary;
    }
    border-bottom: 1px solid $secondary;
    h3 {
      font-size: 20px;
      margin: 0;
      padding: .9em 0 .9rem .5rem;
      .accordion-title {
        display: flex;
        align-items: center;
        .header-icon {
          img {
            max-width: 30px;
            width: 100%;
            margin: 0;
            filter: $filter-to-secondary;
          }
        }
        @include media-breakpoint-down(sm) {
          .header-icon img {
            max-width: 20px;
          }
        }
      }
      img {
        width: 15px;
        margin: 0 10px 0 10px;
      }
      &:focus {
        outline: 0;
      }
      img.when-open {
        transform: rotate(-90deg);
      }
      &.collapsed img.when-open,
      &.not-collapsed img.when-closed {
        display: none;
      }
    }
    .accordion-content {
      padding: 0 55px 20px 0;
      @include media-breakpoint-down(sm) {
        padding: 0 0 10px 0;
        .addition-icon-on-the-left {
          min-width: 50px!important;
          height: 100%;
          img {
            max-width: 20px!important;
          }
        }
      }
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }
      .addition-icon-on-the-left {
        min-width: 65px;
        height: 100%;
        padding-left: .8rem;
        margin-top: 15px;
        img {
          max-width: 30px;
        }
      }
    }
  }
}
::v-deep ul {
  @extend .list-square;
}
</style>
